<div
  data-cy="sorry_page"
  class="sorry-container"
  [style.background]="config.background"
>
  <b2c-template class="tpl" [template]="config.content" />
</div>
